import { render, staticRenderFns } from "./TeacherSkillInfo.vue?vue&type=template&id=5bfdf33e&scoped=true&"
import script from "./TeacherSkillInfo.vue?vue&type=script&lang=js&"
export * from "./TeacherSkillInfo.vue?vue&type=script&lang=js&"
import style0 from "./TeacherSkillInfo.vue?vue&type=style&index=0&id=5bfdf33e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfdf33e",
  null
  
)

export default component.exports